module.exports = __webpack_public_path__ + "img/home_contact_bg.a60c5576.jpg";